var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"player",class:"id" + _vm.id})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /Users/Smelkov/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b681ea32","hasScoped":false,"buble":{"transforms":{}}}!/Users/Smelkov/node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=slm!/Users/Smelkov/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/Player.vue
// module id = 21
// module chunks = 0